<div>
  <h1>{{ title }}</h1>
  @if (manual) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-description>Referenz</mat-panel-description>
      </mat-expansion-panel-header>
      <div [innerHTML]="manual"></div>
    </mat-expansion-panel>
  }

  <form class="input-form" [formGroup]="form">
    <table class="mat-elevation-z8">
      <thead>
        <th></th>
        @if (isTwoSided) {
          <th class="input-column head">Links</th>
          <th class="input-column head">Rechts</th>
        } @else {
          <th class="input-column head"></th>
        }
      </thead>
      <tbody>
        @for (row of dataHtml; track row.name) {
          <tr>
            <td>
              <h3>{{ row.label }}</h3>
            </td>
            <td class="input-column">
              <div class="input">
                <input
                  [ngClass]="{ 'input-error': form.status === 'INVALID' }"
                  [tabIndex]="startTabIndex + $index"
                  [formControlName]="row.controlLeftName"
                  type="number"
                  appNumbersOnly
                  placeholder="" />
                @if (form.controls[row.controlLeftName].invalid) {
                  <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                }
              </div>
              @if (form.controls[row.controlLeftName].hasError('max')) {
                <mat-error class="input-error">Wert zu groß</mat-error>
              }
              @if (form.controls[row.controlLeftName].hasError('min')) {
                <mat-error class="input-error">Wert zu klein</mat-error>
              }
            </td>
            @if (isTwoSided) {
              <td class="input-column">
                <div class="input">
                  <input
                    [ngClass]="{ 'input-error': form.status === 'INVALID' }"
                    [tabIndex]="startTabIndex + $index + dataHtml.length"
                    [formControlName]="row.controlRightName"
                    type="number"
                    appNumbersOnly
                    placeholder="" />
                  @if (form.controls[row.controlRightName].invalid) {
                    <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                  }
                </div>
                @if (form.controls[row.controlRightName].hasError('max')) {
                  <mat-error class="input-error">Wert zu groß</mat-error>
                }
                @if (form.controls[row.controlRightName].hasError('min')) {
                  <mat-error class="input-error">Wert zu klein</mat-error>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
    <!-- <mat-form-field class="note">
      <mat-label>Zusätzliche Hinweise (optional)</mat-label>
      <textarea
        [tabIndex]="startTabIndex + dataHtml.length * 2 + 1"
        type="text"
        matInput
        formControlName="note"
        placeholder=""></textarea>
    </mat-form-field> -->
  </form>
</div>
